"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionHeadingRegistryWidget = exports.AccordionHeadingWidget = void 0;
var classnames_1 = __importDefault(require("classnames"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var AccordionContext_1 = require("./AccordionContext");
var withCentredAccordionButton_1 = __importDefault(require("ContentTokens/SharedWidgetComponents/Accordion/withCentredAccordionButton"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var PlaceholderContext_1 = __importDefault(require("Project/QwilrEditor/Placeholder/PlaceholderContext"));
var ACCORDION_HEADING_BASE_CLASS_NAME = "accordion-widget-heading";
exports.AccordionHeadingWidget = (0, withCentredAccordionButton_1.default)((0, AccordionContext_1.withAccordionContext)((0, mobx_react_1.observer)(function (_a) {
    var _b, _c;
    var attributes = _a.attributes, children = _a.children, _d = _a.context, expanded = _d.expanded, setExpanded = _d.setExpanded, isVisualStyleAccordion = _d.isVisualStyleAccordion, backgroundImageUrl = _d.backgroundImageUrl, handleSwapImageClick = _d.handleSwapImageClick, handleVisualAccordionImageClick = _d.handleVisualAccordionImageClick, showControls = _d.showControls, buttonTopMargin = _a.buttonTopMargin;
    return (react_1.default.createElement("div", __assign({}, attributes, { className: (0, classnames_1.default)(ACCORDION_HEADING_BASE_CLASS_NAME, (_b = {},
            _b["".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "--expanded")] = expanded,
            _b["".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "--collapsed")] = !expanded,
            _b)), style: isVisualStyleAccordion
            ? {
                backgroundImage: "url(".concat(backgroundImageUrl, ")"),
            }
            : undefined, onMouseDown: handleVisualAccordionImageClick }),
        isVisualStyleAccordion && (react_1.default.createElement(react_transition_group_1.CSSTransition, { in: isVisualStyleAccordion && showControls, timeout: kaleidoscope_2.AnimationDuration.Medium, classNames: "".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__controls-"), mountOnEnter: true, unmountOnExit: true },
            react_1.default.createElement("div", { className: "".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__controls"), contentEditable: false },
                react_1.default.createElement(kaleidoscope_1.IconButton, { icon: react_1.default.createElement(icons_1.Image, null), tooltip: { content: "Swap image" }, type: kaleidoscope_1.ButtonType.Secondary, "aria-label": "swap image", onClick: handleSwapImageClick })))),
        react_1.default.createElement("div", { className: "".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button-wrapper"), contentEditable: false, style: { marginTop: buttonTopMargin } },
            react_1.default.createElement("button", { onMouseDown: function (e) {
                    e.nativeEvent.stopImmediatePropagation();
                }, onClick: function () { return setExpanded(!expanded); }, className: (0, classnames_1.default)("".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button"), "user-font", (_c = {},
                    _c["".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button--expanded")] = expanded,
                    _c["".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__button--collapsed")] = !expanded,
                    _c)) })),
        react_1.default.createElement("div", { className: "".concat(ACCORDION_HEADING_BASE_CLASS_NAME, "__content") },
            react_1.default.createElement(PlaceholderContext_1.default, { placeholders: {
                    heading1: "Add a heading",
                    heading2: "Add a heading",
                    paragraph: "Add a heading",
                } }, children))));
})));
var AccordionHeadingRegistryWidget = function (_a) {
    var children = _a.children;
    return (react_1.default.createElement(exports.AccordionHeadingWidget, { attributes: {}, isSelected: false }, children));
};
exports.AccordionHeadingRegistryWidget = AccordionHeadingRegistryWidget;
